import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangMurau() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-murau-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-murau-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="murau" />
      </div>
    </div>
  );
}

export default BaumumfangMurau;
